export default "__VITE_ASSET__DfSKFah1__"